module.exports = __webpack_public_path__ + "img/icon03.0d0e7f1e.png";